import { render, staticRenderFns } from "./logisticsInfoModal.vue?vue&type=template&id=1f84293b&scoped=true"
import script from "./logisticsInfoModal.vue?vue&type=script&lang=js"
export * from "./logisticsInfoModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f84293b",
  null
  
)

export default component.exports